<div class="page-wrapper">

  <div class="page-header">
    <div class="page-title">
      <svg class="page-title__icon" width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M2 0C0.895431 0 0 0.89543 0 2V2.5H14V2C14 0.89543 13.1046 0 12 0H2Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 4H0V9C0 10.1046 0.895431 11 2 11H12C13.1046 11 14 10.1046 14 9V4Z" fill="currentColor"/>
      </svg>
      <h1 class="page-title__text">Transactions</h1>
    </div>
    <p class="page-title__sub">Every deliberate wallet movement across the platform.</p>
  </div>

  @if (totals; as t) {
    <app-admin-totals-card
      [description]="hasFilters ? 'The transactions matching your filters.' : 'Every transaction on the platform.'"
      [filterLabel]="totalsFilterLabel"
      [columns]="4"
      [loading]="isLoading"
    >
      <div appTotalsFigure label="In" info="Money added to wallets by these transactions, such as top-ups and grants." note="Added to wallets">{{ t.creditedCents | money }} {{ t.currency | uppercase }}</div>
      <div appTotalsFigure label="Out" info="Money taken out of wallets by these transactions." note="Taken from wallets"><span class="billing-card__balance--negative">{{ signed(t.debitedCents) }} {{ t.currency | uppercase }}</span></div>
      <div appTotalsFigure label="Net" info="In minus out: how much wallets changed overall through these transactions." note="In minus out"><span [class.billing-card__balance--negative]="netCents < 0">{{ signed(netCents) }} {{ t.currency | uppercase }}</span></div>
      <div appTotalsFigure label="Transactions" info="How many transactions match the current filters." [note]="hasFilters ? 'Matching your filters' : 'Every wallet movement'">{{ (pagination?.total ?? rows.length) | number }}</div>
    </app-admin-totals-card>
  } @else if (!hasLoadedOnce) {
    <app-admin-totals-card [skeletonLabels]="['In', 'Out', 'Net', 'Transactions']" [columns]="4" />
  }

  <div class="api-card api-card--full" #listCard>
    <div class="admin-filter-bar">
      <div class="admin-filter-bar__search">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="7.25" cy="7.25" r="4.75" stroke="currentColor" stroke-width="1.6"/><path d="M10.75 10.75 14 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
        <input type="text" placeholder="Organization (slug)..." [ngModel]="q" (ngModelChange)="onQueryChange($event)" />
      </div>
      @if (phone) {
        <!-- Phones: the other filters live in a sheet (admin-filters-sheet). -->
        <button type="button" class="admin-filter-bar__filters" (click)="openFilters()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2.5 4h11M4.5 8h7M6.5 12h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
          Filters
          @if (activeFilterCount) {
            <span class="admin-filter-bar__count">{{ activeFilterCount }}</span>
          }
        </button>
      } @else {
        <select class="admin-filter-bar__select" [ngModel]="kind" (ngModelChange)="onKindChange($event)">
          <option value="">All kinds</option>
          <option value="topup">Top-up</option>
          <option value="grant">Grant</option>
          <option value="adjustment">Adjustment</option>
          <option value="refund">Refund</option>
        </select>
        <input type="date" class="admin-filter-bar__select" [ngModel]="from" (ngModelChange)="onFromChange($event)" title="From" />
        <input type="date" class="admin-filter-bar__select" [ngModel]="to" (ngModelChange)="onToChange($event)" title="To" />
      }
    </div>

    @if (isLoading) {
      <div class="admin-table-scroll">
        <table class="billing-table admin-stack admin-stack--txns">
          <thead>
            <tr>
              <th>Date</th>
              <th>Organization</th>
              <th>Kind</th>
              <th>Description</th>
              <th class="col-num">Amount</th>
              <th class="col-num">Balance after</th>
            </tr>
          </thead>
          <tbody>
            @for (i of [1,2,3,4,5]; track i) {
              <tr>
                <td><app-skeleton width="80px" height="14px"></app-skeleton></td>
                <td><app-skeleton width="65%" height="14px"></app-skeleton></td>
                <td><app-skeleton width="60px" height="20px" radius="4px"></app-skeleton></td>
                <td><app-skeleton width="85%" height="14px"></app-skeleton></td>
                <td><app-skeleton width="70px" height="14px"></app-skeleton></td>
                <td><app-skeleton width="70px" height="14px"></app-skeleton></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else if (rows.length) {
      <div class="admin-table-scroll">
        <table class="billing-table admin-stack admin-stack--txns">
          <thead>
            <tr>
              <th>Date</th>
              <th>Organization</th>
              <th>Kind</th>
              <th>Description</th>
              <th class="col-num">Amount</th>
              <th class="col-num">Balance after</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.id) {
              <tr>
                <td>{{ row.createdAt | date:'MMM d, y, HH:mm' }}</td>
                <td>
                  @if (row.organization) {
                    <a [routerLink]="['/admin/organizations', row.organization.slug]" class="link">{{ row.organization.name }}</a>
                  } @else {
                    -
                  }
                </td>
                <td><span [class]="'txn-kind-badge txn-kind-badge--' + row.kind">{{ row.kind }}</span></td>
                <td>
                  {{ row.description || '-' }}
                  @if (row.createdBy) {
                    <br><span class="cell-status--muted">by {{ row.createdBy.name }}</span>
                  }
                </td>
                <td class="col-num" [class.billing-card__balance--negative]="!row.isCredit">
                  {{ row.isCredit ? '+' : '' }}{{ row.amountCents | money }} {{ row.currency | uppercase }}
                </td>
                <td class="col-num" [class.billing-card__balance--negative]="row.balanceAfterCents < 0">
                  {{ row.balanceAfterCents | money }} {{ row.currency | uppercase }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="table-footer">
        <span>{{ pagination?.total ?? rows.length | number }} transaction{{ (pagination?.total ?? rows.length) === 1 ? '' : 's' }}</span>
        @if (pagination && pagination.pages > 1) {
          <div class="table-footer__pager">
            <button type="button" class="btn--secondary" [disabled]="page <= 1" (click)="goToPage(page - 1)">Previous</button>
            <span>Page {{ page }} of {{ pagination.pages }}</span>
            <button type="button" class="btn--secondary" [disabled]="page >= pagination.pages" (click)="goToPage(page + 1)">Next</button>
          </div>
        }
      </div>
    } @else {
      <div class="empty-state">
        @if (hasFilters) {
          <p class="empty-state__title">No transactions match your filters.</p>
          <p class="empty-state__desc">Try a different organization or kind, or clear the filters.</p>
          <button type="button" class="btn--secondary empty-state__action" (click)="clearFilters()">Clear filters</button>
        } @else {
          <p class="empty-state__title">No transactions yet.</p>
          <p class="empty-state__desc">Top-ups, grants, refunds and adjustments appear here.</p>
        }
      </div>
    }
  </div>

</div>
